const templateBlog = {
  init: function () {
    window.bLazy.load($(".news__image"));
    templateBlog.events();
  },

  events: function () {},
};
export default templateBlog;
